<template>
  <div class="app-members">
    <!-- DIY -->
    <AppMembersSection
      v-allowed:employee
      title="DIY"
      :users="employeeAvailableUsers"
      @selected="userSelected"
    />
    <!-- CLIENT -->
    <AppMembersSection
      v-if="accountAvailableUsers.length"
      :title="clientSectionTitle"
      :users="accountAvailableUsers"
      @selected="userSelected"
    />
  </div>
</template>

<script>
// Utils
import { mapState } from 'vuex'
import { removeArrayDuplicates } from 'Utils'
// Components
import AppMembersSection from './components/AppMembersSection'

export default {
  name: 'AppMembers',

  components: {
    AppMembersSection,
  },

  methods: {
    userSelected(user) {
      this.$emit('selected', user)
    },
  },

  computed: {
    isEmployee() {
      return this.currentUser.type === 'EMPLOYEE'
    },

    ...mapState({
      diyUsers: (state) => state.user.diyUsers,
      accountUsers: (state) => state.client.account.users,
      currentUser: (state) => state.user.currentUser,
      currentUsers: (state) => state.cards.currentCard.users,
    }),

    employeeAvailableUsers() {
      return removeArrayDuplicates(this.diyUsers, this.currentUsers, 'user', 'id')
    },

    accountAvailableUsers() {
      return removeArrayDuplicates(this.accountUsers, this.currentUsers, 'user', 'id')
    },

    clientSectionTitle() {
      return this.isEmployee ? 'Cliente' : this.$t('ui.generals.members_editors_your_team')
    },
  },

  async created() {
    if (!this.diyUsers && this.isEmployee) {
      await this.$store.dispatch('user/loadDIYUsers')
    }
  },
}
</script>

<style scoped>
.app-members {
  max-width: 300px;
  padding-bottom: 10px;
  margin-top: 10px;
}
</style>
